// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  E.g. 
  @include mix.position-fix(-15px, 0 0 -15px 0);
  @include mix.respond(1280px) { @include mix.position-reset(); }
*/
.mat-elevation-z0, .mat-mdc-elevation-specific.mat-elevation-z0 {
  box-shadow: var(--mat-app-elevation-shadow-level-0, 0px 0px 0px 0px --mat-sys-shadow, 0px 0px 0px 0px --mat-sys-shadow, 0px 0px 0px 0px --mat-sys-shadow);
}

.mat-elevation-z1, .mat-mdc-elevation-specific.mat-elevation-z1 {
  box-shadow: var(--mat-app-elevation-shadow-level-1, 0px 2px 1px -1px --mat-sys-shadow, 0px 1px 1px 0px --mat-sys-shadow, 0px 1px 3px 0px --mat-sys-shadow);
}

.mat-elevation-z2, .mat-mdc-elevation-specific.mat-elevation-z2 {
  box-shadow: var(--mat-app-elevation-shadow-level-2, 0px 3px 1px -2px --mat-sys-shadow, 0px 2px 2px 0px --mat-sys-shadow, 0px 1px 5px 0px --mat-sys-shadow);
}

.mat-elevation-z3, .mat-mdc-elevation-specific.mat-elevation-z3 {
  box-shadow: var(--mat-app-elevation-shadow-level-3, 0px 3px 3px -2px --mat-sys-shadow, 0px 3px 4px 0px --mat-sys-shadow, 0px 1px 8px 0px --mat-sys-shadow);
}

.mat-elevation-z4, .mat-mdc-elevation-specific.mat-elevation-z4 {
  box-shadow: var(--mat-app-elevation-shadow-level-4, 0px 2px 4px -1px --mat-sys-shadow, 0px 4px 5px 0px --mat-sys-shadow, 0px 1px 10px 0px --mat-sys-shadow);
}

.mat-elevation-z5, .mat-mdc-elevation-specific.mat-elevation-z5 {
  box-shadow: var(--mat-app-elevation-shadow-level-5, 0px 3px 5px -1px --mat-sys-shadow, 0px 5px 8px 0px --mat-sys-shadow, 0px 1px 14px 0px --mat-sys-shadow);
}

.mat-elevation-z6, .mat-mdc-elevation-specific.mat-elevation-z6 {
  box-shadow: var(--mat-app-elevation-shadow-level-6, 0px 3px 5px -1px --mat-sys-shadow, 0px 6px 10px 0px --mat-sys-shadow, 0px 1px 18px 0px --mat-sys-shadow);
}

.mat-elevation-z7, .mat-mdc-elevation-specific.mat-elevation-z7 {
  box-shadow: var(--mat-app-elevation-shadow-level-7, 0px 4px 5px -2px --mat-sys-shadow, 0px 7px 10px 1px --mat-sys-shadow, 0px 2px 16px 1px --mat-sys-shadow);
}

.mat-elevation-z8, .mat-mdc-elevation-specific.mat-elevation-z8 {
  box-shadow: var(--mat-app-elevation-shadow-level-8, 0px 5px 5px -3px --mat-sys-shadow, 0px 8px 10px 1px --mat-sys-shadow, 0px 3px 14px 2px --mat-sys-shadow);
}

.mat-elevation-z9, .mat-mdc-elevation-specific.mat-elevation-z9 {
  box-shadow: var(--mat-app-elevation-shadow-level-9, 0px 5px 6px -3px --mat-sys-shadow, 0px 9px 12px 1px --mat-sys-shadow, 0px 3px 16px 2px --mat-sys-shadow);
}

.mat-elevation-z10, .mat-mdc-elevation-specific.mat-elevation-z10 {
  box-shadow: var(--mat-app-elevation-shadow-level-10, 0px 6px 6px -3px --mat-sys-shadow, 0px 10px 14px 1px --mat-sys-shadow, 0px 4px 18px 3px --mat-sys-shadow);
}

.mat-elevation-z11, .mat-mdc-elevation-specific.mat-elevation-z11 {
  box-shadow: var(--mat-app-elevation-shadow-level-11, 0px 6px 7px -4px --mat-sys-shadow, 0px 11px 15px 1px --mat-sys-shadow, 0px 4px 20px 3px --mat-sys-shadow);
}

.mat-elevation-z12, .mat-mdc-elevation-specific.mat-elevation-z12 {
  box-shadow: var(--mat-app-elevation-shadow-level-12, 0px 7px 8px -4px --mat-sys-shadow, 0px 12px 17px 2px --mat-sys-shadow, 0px 5px 22px 4px --mat-sys-shadow);
}

.mat-elevation-z13, .mat-mdc-elevation-specific.mat-elevation-z13 {
  box-shadow: var(--mat-app-elevation-shadow-level-13, 0px 7px 8px -4px --mat-sys-shadow, 0px 13px 19px 2px --mat-sys-shadow, 0px 5px 24px 4px --mat-sys-shadow);
}

.mat-elevation-z14, .mat-mdc-elevation-specific.mat-elevation-z14 {
  box-shadow: var(--mat-app-elevation-shadow-level-14, 0px 7px 9px -4px --mat-sys-shadow, 0px 14px 21px 2px --mat-sys-shadow, 0px 5px 26px 4px --mat-sys-shadow);
}

.mat-elevation-z15, .mat-mdc-elevation-specific.mat-elevation-z15 {
  box-shadow: var(--mat-app-elevation-shadow-level-15, 0px 8px 9px -5px --mat-sys-shadow, 0px 15px 22px 2px --mat-sys-shadow, 0px 6px 28px 5px --mat-sys-shadow);
}

.mat-elevation-z16, .mat-mdc-elevation-specific.mat-elevation-z16 {
  box-shadow: var(--mat-app-elevation-shadow-level-16, 0px 8px 10px -5px --mat-sys-shadow, 0px 16px 24px 2px --mat-sys-shadow, 0px 6px 30px 5px --mat-sys-shadow);
}

.mat-elevation-z17, .mat-mdc-elevation-specific.mat-elevation-z17 {
  box-shadow: var(--mat-app-elevation-shadow-level-17, 0px 8px 11px -5px --mat-sys-shadow, 0px 17px 26px 2px --mat-sys-shadow, 0px 6px 32px 5px --mat-sys-shadow);
}

.mat-elevation-z18, .mat-mdc-elevation-specific.mat-elevation-z18 {
  box-shadow: var(--mat-app-elevation-shadow-level-18, 0px 9px 11px -5px --mat-sys-shadow, 0px 18px 28px 2px --mat-sys-shadow, 0px 7px 34px 6px --mat-sys-shadow);
}

.mat-elevation-z19, .mat-mdc-elevation-specific.mat-elevation-z19 {
  box-shadow: var(--mat-app-elevation-shadow-level-19, 0px 9px 12px -6px --mat-sys-shadow, 0px 19px 29px 2px --mat-sys-shadow, 0px 7px 36px 6px --mat-sys-shadow);
}

.mat-elevation-z20, .mat-mdc-elevation-specific.mat-elevation-z20 {
  box-shadow: var(--mat-app-elevation-shadow-level-20, 0px 10px 13px -6px --mat-sys-shadow, 0px 20px 31px 3px --mat-sys-shadow, 0px 8px 38px 7px --mat-sys-shadow);
}

.mat-elevation-z21, .mat-mdc-elevation-specific.mat-elevation-z21 {
  box-shadow: var(--mat-app-elevation-shadow-level-21, 0px 10px 13px -6px --mat-sys-shadow, 0px 21px 33px 3px --mat-sys-shadow, 0px 8px 40px 7px --mat-sys-shadow);
}

.mat-elevation-z22, .mat-mdc-elevation-specific.mat-elevation-z22 {
  box-shadow: var(--mat-app-elevation-shadow-level-22, 0px 10px 14px -6px --mat-sys-shadow, 0px 22px 35px 3px --mat-sys-shadow, 0px 8px 42px 7px --mat-sys-shadow);
}

.mat-elevation-z23, .mat-mdc-elevation-specific.mat-elevation-z23 {
  box-shadow: var(--mat-app-elevation-shadow-level-23, 0px 11px 14px -7px --mat-sys-shadow, 0px 23px 36px 3px --mat-sys-shadow, 0px 9px 44px 8px --mat-sys-shadow);
}

.mat-elevation-z24, .mat-mdc-elevation-specific.mat-elevation-z24 {
  box-shadow: var(--mat-app-elevation-shadow-level-24, 0px 11px 15px -7px --mat-sys-shadow, 0px 24px 38px 3px --mat-sys-shadow, 0px 9px 46px 8px --mat-sys-shadow);
}

html {
  --mat-sys-on-surface: initial;
}

.mat-app-background {
  background-color: var(--mat-app-background-color, var(--mat-sys-background, transparent));
  color: var(--mat-app-text-color, var(--mat-sys-on-background, inherit));
}

.backdrop {
  display: flex;
  height: 100vh;
}

.pic {
  background-color: #fafafa;
  background-image: url("/assets/img/CO-ResolvED-mark-only.svg");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 580px auto;
  display: block;
  width: 70%;
}
@media only screen and (max-width: 1200px) {
  .pic {
    width: 60%;
  }
}
@media only screen and (max-width: 950px) {
  .pic {
    background-size: 380px auto;
  }
}
@media only screen and (max-width: 768px) {
  .pic {
    display: none;
  }
}

.sed284 {
  height: 100px;
  background-image: url("/assets/img/sed-284.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: contain;
  display: block;
  margin-top: 30px;
}

.form {
  align-items: center;
  box-shadow: -4px 0 16px -6px rgba(47, 49, 100, 0.1);
  display: flex;
  flex: 1;
  justify-content: center;
  margin-left: 0;
  padding: 0 45px;
  position: static;
  width: 25vw;
}
@media only screen and (max-width: 1200px) {
  .form {
    padding: 0 25px;
  }
}
@media only screen and (max-width: 768px) {
  .form {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: 0;
    transform: translate(-50%, -50%);
  }
}

@media (max-width: 768px) {
  .pic {
    background-image: url("/assets/moren-hsu-VLaKsTkmVhk-unsplash.jpg");
    background-size: cover;
    height: 40vh;
    width: 100%;
  }
  .form {
    align-items: center;
    display: flex;
    height: 60vh;
    justify-content: center;
    width: 100%;
  }
}
.login-form {
  display: flex;
  flex-direction: column;
  max-width: 350px;
  text-align: center;
}

.login-field {
  width: 100%;
}

.forget-password {
  margin-top: 8px;
}

.buttons {
  margin-top: 8px;
}

.test-user-list {
  font-size: 12px;
}

.shift-right {
  right: 1.15rem;
}

.error {
  color: #c3002f;
}

.stronger {
  font-size: larger;
  font-weight: 600;
}

/* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version. */
::ng-deep .mat-select-arrow {
  border-left: 20px solid transparent !important;
  border-right: none !important;
  border-top: 20px solid transparent !important;
  border-image-source: url("/assets/img/languageassets/icon20x24px-exported.jpg") !important;
  border-image-repeat: stretch !important;
}

.instructions {
  text-align: left;
}

::ng-deep .instructions p {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/abstracts/_mixins.scss","webpack://./node_modules/@angular/material/core/_core.scss","webpack://./src/app/public/surveys/parent-search-by-key-page/parent-search-by-key-page.component.scss","webpack://./src/styles/abstracts/_variables.scss"],"names":[],"mappings":"AAyBE;;;;CAAA;ACmBI;EACE,yJAAA;ACtCR;;ADqCM;EACE,0JAAA;AClCR;;ADiCM;EACE,0JAAA;AC9BR;;AD6BM;EACE,0JAAA;AC1BR;;ADyBM;EACE,2JAAA;ACtBR;;ADqBM;EACE,2JAAA;AClBR;;ADiBM;EACE,4JAAA;ACdR;;ADaM;EACE,4JAAA;ACVR;;ADSM;EACE,4JAAA;ACNR;;ADKM;EACE,4JAAA;ACFR;;ADCM;EACE,8JAAA;ACER;;ADHM;EACE,8JAAA;ACMR;;ADPM;EACE,8JAAA;ACUR;;ADXM;EACE,8JAAA;ACcR;;ADfM;EACE,8JAAA;ACkBR;;ADnBM;EACE,8JAAA;ACsBR;;ADvBM;EACE,+JAAA;AC0BR;;AD3BM;EACE,+JAAA;AC8BR;;AD/BM;EACE,+JAAA;ACkCR;;ADnCM;EACE,+JAAA;ACsCR;;ADvCM;EACE,gKAAA;AC0CR;;AD3CM;EACE,gKAAA;AC8CR;;AD/CM;EACE,gKAAA;ACkDR;;ADnDM;EACE,gKAAA;ACsDR;;ADvDM;EACE,gKAAA;AC0DR;;ADvFE;EACE,6BAAA;AC0FJ;;ADnFI;EACE,yFAAA;EACA,uEAAA;ACsFN;;AA1GA;EACE,aAAA;EACA,aAAA;AA6GF;;AA1GA;EACE,yBAAA;EACA,8DAAA;EACA,kCAAA;EACA,4BAAA;EACA,2BAAA;EACA,cAAA;EACA,UAAA;AA6GF;AF5GI;EERJ;IAUI,UAAA;EA8GF;AACF;AFjHI;EERJ;IAcI,2BAAA;EA+GF;AACF;AFtHI;EERJ;IAkBI,aAAA;EAgHF;AACF;;AA7GA;EACE,aAAA;EACA,gDAAA;EACA,kCAAA;EACA,4BAAA;EACA,wBAAA;EACA,cAAA;EACA,gBAAA;AAgHF;;AA7GA;EACE,mBAAA;EACA,mDAAA;EACA,aAAA;EACA,OAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAgHF;AFjJI;EEwBJ;IAYI,eAAA;EAiHF;AACF;AFtJI;EEwBJ;IAgBI,kBAAA;IACA,QAAA;IACA,SAAA;IACA,cAAA;IACA,gCAAA;EAkHF;AACF;;AA/GA;EACE;IACE,mEAAA;IACA,sBAAA;IACA,YAAA;IACA,WAAA;EAkHF;EA/GA;IACE,mBAAA;IACA,aAAA;IACA,YAAA;IACA,uBAAA;IACA,WAAA;EAiHF;AACF;AA9GA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;AAgHF;;AA7GA;EACE,WAAA;AAgHF;;AA7GA;EACE,eCtFS;ADsMX;;AA7GA;EACE,eC1FS;AD0MX;;AA7GA;EACE,eAAA;AAgHF;;AA7GA;EACE,cAAA;AAgHF;;AA7GA;EACE,cAAA;AAgHF;;AA7GA;EACE,iBAAA;EACA,gBAAA;AAgHF;;AA7GA,6HAAA;AACA;EACE,8CAAA;EACA,6BAAA;EACA,6CAAA;EACA,0FAAA;EACA,uCAAA;AAgHF;;AA7GA;EACE,gBAAA;AAgHF;;AA7GA;EACE,0BAAA;EACA,6BAAA;AAgHF","sourcesContent":["// BEM Mixins\r\n@mixin e($element) {\r\n    &__#{$element} {\r\n      @content;\r\n    }\r\n  }\r\n  @mixin m($modifier) {\r\n    &--#{$modifier} {\r\n      @content;\r\n    }\r\n  }\r\n  @mixin c($child) {\r\n    &-#{$child} {\r\n      @content;\r\n    }\r\n  }\r\n  \r\n  // Media Query Mixin\r\n  @mixin respond($respond) {\r\n    @media only screen and (max-width: #{$respond}) {\r\n      @content;\r\n    }\r\n  }\r\n  \r\n  // Position fixing (generally used for forms)\r\n  /*\r\n    E.g. \r\n    @include mix.position-fix(-15px, 0 0 -15px 0);\r\n    @include mix.respond(1280px) { @include mix.position-reset(); }\r\n  */\r\n  @mixin position-fix($top, $margin: 0 0 0 0) {\r\n    margin: $margin;\r\n    position: relative;\r\n    top: $top;\r\n  }\r\n  \r\n  @mixin position-reset() {\r\n    margin: 0;\r\n    position: static;\r\n    top: 0;\r\n  }","@use './m3-app';\n@use './tokens/token-utils';\n@use './style/elevation';\n\n$fallbacks: m3-app.get-tokens();\n\n/// @deprecated This mixin is a no-op and is going to be removed in v21.\n@mixin core() {}\n\n// Emits the mat-app-background CSS class. This predefined class sets the\n// background color and text color of an element.\n@mixin app-background() {\n  // TODO: Move ripple styles to be dynamically loaded instead of in core.\n  // This variable is used as a fallback for the ripple element's\n  // background color. However, if it isn't defined anywhere, then MSS\n  // complains in its verification stage.\n  html {\n    --mat-sys-on-surface: initial;\n  }\n\n  // Wrapper element that provides the theme background when the\n  // user's content isn't inside of a `mat-sidenav-container`.\n  @at-root {\n    // Note: we need to emit fallback values here to avoid errors in internal builds.\n    .mat-app-background {\n      background-color: token-utils.slot(app-background-color, $fallbacks, transparent);\n      color: token-utils.slot(app-text-color, $fallbacks, inherit);\n    }\n  }\n}\n\n// Emits CSS classes for applying elevation. These classes follow the pattern\n// mat-elevation-z#, where # is the elevation number you want, from 0 to 24.\n// These predefined classes use the CSS box-shadow settings defined by the\n// Material Design specification.\n@mixin elevation-classes() {\n  @at-root {\n    // Provides external CSS classes for each elevation value. Each CSS class is formatted as\n    // `mat-elevation-z$z-value` where `$z-value` corresponds to the z-space to which the element\n    // is elevated.\n    @for $z-value from 0 through 24 {\n      $selector: elevation.$prefix + $z-value;\n      // We need the `mat-mdc-elevation-specific`, because some MDC mixins\n      // come with elevation baked in and we don't have a way of removing it.\n      .#{$selector}, .mat-mdc-elevation-specific.#{$selector} {\n        box-shadow: token-utils.slot('app-elevation-shadow-level-#{$z-value}', $fallbacks, none);\n      }\n    }\n  }\n}\n","@use \"sass:map\";\r\n\r\n@use \"./src/styles/abstracts/mixins\" as mix;\r\n@use \"./src/styles/abstracts/variables\" as var;\r\n@use \"./src/styles/theme/theme-variables\" as theme;\r\n\r\n.backdrop {\r\n  display: flex;\r\n  height: 100vh;\r\n}\r\n\r\n.pic {\r\n  background-color: #fafafa;\r\n  background-image: url(\"/assets/img/CO-ResolvED-mark-only.svg\");\r\n  background-position: center center;\r\n  background-repeat: no-repeat;\r\n  background-size: 580px auto;\r\n  display: block;\r\n  width: 70%;\r\n\r\n  @include mix.respond(1200px) {\r\n    width: 60%;\r\n  }\r\n\r\n  @include mix.respond(950px) {\r\n    background-size: 380px auto;\r\n  }\r\n\r\n  @include mix.respond(768px) {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.sed284 {\r\n  height: 100px;\r\n  background-image: url(\"/assets/img/sed-284.png\");\r\n  background-position: center center;\r\n  background-repeat: no-repeat;\r\n  background-size: contain;\r\n  display: block;\r\n  margin-top: 30px;\r\n}\r\n\r\n.form {\r\n  align-items: center;\r\n  box-shadow: -4px 0 16px -6px rgba(map.get(theme.$ascend-primary, 500), 0.1);\r\n  display: flex;\r\n  flex: 1;\r\n  justify-content: center;\r\n  margin-left: 0;\r\n  padding: 0 45px;\r\n  position: static;\r\n  width: 25vw;\r\n\r\n  @include mix.respond(1200px) {\r\n    padding: 0 25px;\r\n  }\r\n\r\n  @include mix.respond(768px) {\r\n    position: absolute;\r\n    top: 50%;\r\n    left: 50%;\r\n    margin-left: 0;\r\n    transform: translate(-50%, -50%);\r\n  }\r\n}\r\n\r\n@media (max-width: var.$tablet) {\r\n  .pic {\r\n    background-image: url(\"/assets/moren-hsu-VLaKsTkmVhk-unsplash.jpg\");\r\n    background-size: cover;\r\n    height: 40vh;\r\n    width: 100%;\r\n  }\r\n\r\n  .form {\r\n    align-items: center;\r\n    display: flex;\r\n    height: 60vh;\r\n    justify-content: center;\r\n    width: 100%;\r\n  }\r\n}\r\n\r\n.login-form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  max-width: 350px;\r\n  text-align: center;\r\n}\r\n\r\n.login-field {\r\n  width: 100%;\r\n}\r\n\r\n.forget-password {\r\n  margin-top: var.$space-sm;\r\n}\r\n\r\n.buttons {\r\n  margin-top: var.$space-sm;\r\n}\r\n\r\n.test-user-list {\r\n  font-size: 12px;\r\n}\r\n\r\n.shift-right {\r\n  right: 1.15rem;\r\n}\r\n\r\n.error {\r\n  color: #c3002f;\r\n}\r\n\r\n.stronger {\r\n  font-size: larger;\r\n  font-weight: 600;\r\n}\r\n\r\n/* TODO(mdc-migration): The following rule targets internal classes of select that may no longer apply for the MDC version. */\r\n::ng-deep .mat-select-arrow {\r\n  border-left: 20px solid transparent !important;\r\n  border-right: none !important;\r\n  border-top: 20px solid transparent !important;\r\n  border-image-source: url(\"/assets/img/languageassets/icon20x24px-exported.jpg\") !important;\r\n  border-image-repeat: stretch !important;\r\n}\r\n\r\n.instructions {\r\n  text-align: left;\r\n}\r\n\r\n::ng-deep .instructions p {\r\n  margin-top: 0px !important;\r\n  margin-bottom: 0px !important;\r\n}\r\n","// Brand Colors\r\n$brand-blue-light: #a8c0e4;\r\n$brand-maroon: #a12041;\r\n$brand-maroon-swap: #1a8435;\r\n$brand-gray-darker: #58595b;\r\n$brand-gray-dark: #808285;\r\n$brand-gray-light: #a7a9ac;\r\n$brand-gray-lightest: #d1d3d4;\r\n\r\n// Spacing\r\n$space-sm: 8px;\r\n$space-md: 16px;\r\n$space-lg: 24px;\r\n\r\n// Side Nav\r\n$side-nav-width: 210px;\r\n$side-nav-color: #f6f6f6;\r\n$side-nav-color-hover: rgba(0, 0, 0, 0.04);\r\n\r\n// Media Res\r\n$tablet: 768px;"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
